import type { FC } from "react";
import { Box } from '@hanzo/ui'

export interface FaqItemProp {
  title: string;
  link: string;
}

export const FaqItem: FC<FaqItemProp> = (props) => {
  const { title, link } = props;
  return (
    <Box className="flex flex-row gap-4 w-[372px]">
      <Box tag="a" href={link} className="text-white text--[20px]">{title}</Box>
      <img src="assets/common/left.svg" alt="left" />
    </Box>
  )
}